<div class="insurance-change-main" data-cy="insurance-change-dialog-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" style="flex-basis: 30px;" data-cy="insurance-change-header-section">
      <div class="section-header-title" data-cy="insurance-change-title-text">
        Change Insurance
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->
    @if (isLoading) {
      <app-tdo-progress-spinner style="height: 100%;" data-cy="insurance-change-loading-spinner"></app-tdo-progress-spinner>
    }
    @if (!isLoading) {
      <div class="section-content" style="flex: 1; display: flex; flex-direction: column; padding: 10px;" data-cy="insurance-change-content-section">
        <div style="margin-bottom: 10px; font-weight: 500;" data-cy="insurance-change-instruction">
          Select a new insurance for this transaction:
        </div>
        <div style="flex: 1; background-color: var(--tdo-background); border-radius: var(--border-radius); padding: 10px; overflow-y: auto; max-height: 250px;" data-cy="insurance-change-list-container">
          @for (insurance of insuranceList; track insurance; let i = $index) {
            <div
              class="insurance-item"
              [ngClass]="{'insurance-item-selected': selectedInsurance === insurance}"
              (click)="onInsuranceClick(insurance)"
              data-cy="insurance-change-item-{{i}}">
              <mat-radio-button
                [checked]="selectedInsurance === insurance"
                [value]="insurance"
                (change)="onInsuranceClick(insurance)"
                data-cy="insurance-change-radio-{{i}}">
                <div style="margin-left: 8px;">
                  <div style="font-weight: 500;" data-cy="insurance-change-name-{{i}}">{{ insurance.Description }}</div>
                  <div style="font-size: 12px; color: #666;" data-cy="insurance-change-details-{{i}}">
                    Order: {{ getInsuranceOrderText(insurance.InsuranceOrder) }}
                    @if (insurance.isExpired) {
                      <span style="color: red; margin-left: 8px;">(Expired)</span>
                    }
                  </div>
                </div>
              </mat-radio-button>
            </div>
          }
          @if (insuranceList.length === 0) {
            <div style="text-align: center; color: #666; margin-top: 20px;" data-cy="insurance-change-no-data">
              No insurance found for this patient
            </div>
          }
        </div>
      </div>
    }
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px; padding-top: 10px; padding-right: 10px;" data-cy="insurance-change-footer-section">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="insurance-change-cancel-button">Cancel</button>
      <button [disabled]="!selectedInsurance" (click)="onSaveClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="insurance-change-save-button">Save</button>
    </div>
  </div>
</div>
